export default "__VITE_ASSET__CjLMihcI__"